import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { i18nextPlugin } from "translation-check";

// The NS's listed below will always be imported
// Only include the NS's that common the rest will be...
// imported dynamically on-demand
export const namespaces = ["_action", "_common", "_messages", "propai"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nextPlugin)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) => import(`@config/i18n/${namespace}/${language}.json`)
    )
  )
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    ns: ["_action", "_common", "_messages", "propai", "propai_properties"],
    defaultNS: "propai",
    fallbackNS: ["propai", "_common"],
    interpolation: {
      formatSeparator: ",",
      escapeValue: false, // not needed for react as it escapes by default
      skipOnVariables: false, // enable nested translation
    },
    returnEmptyString: false,
    partialBundledLanguages: true,
    debug: import.meta.env.REACT_APP_DEBUG_I18NEXT === "true",
  })
  .catch((e) => {
    console.error("I18n init error", e);
  });

export default i18n;
